import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function LaravelDevelopment() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/wordpressdev.jpg)` }}>
        </div>


        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Laravel <br /> Development</h1>
            <p style={{ marginBottom: '3.5rem' }}>Laravel has quickly gained a significant following in the developer community thanks to rapid deployment features and an MVC framework that allows for unmatched flexibility, usability, and functionality. Its simplicity, combined with powerful tools, reduces development times while delivering superior applications.</p>
            <h3>Build secure, scalable web apps with Laravel development.</h3>
            <h4>Benefits of Using Laravel</h4>
            <p style={{ marginBottom: '3.5rem' }}>With other PHP options out there, why opt for Laravel? Developers and businesses alike have been quick to embrace Laravel, thanks to a simplistic yet elegant design framework which allows for the creation of feature-rich, high-end applications, with a fraction of the coding.</p>
            <h4>Laravel offers;</h4>
            <ul style={{ listStyleType: 'square' }}>
              <li>Enhanced performance</li>
              <li>Open-source & powerful community</li>
              <li>Database migration</li>
              <li>Blade templating</li>
              <li>MVC architecture support</li>
            </ul>
            <h4>Why Should You Partner with YGS Web Solutions for Laravel Development?</h4>
            <p style={{ marginBottom: '3.5rem' }}>We are more than simply a team of highly skilled developers, we provide complete end-to-end Laravel development services, from planning, development, design, implementation and support so you can take care of business.</p>
            <h4>Our customers choose us because we offer;</h4>
            <ul style={{ listStyleType: 'square' }}>
              <li>Multifaceted team of experienced professionals</li>
              <li>Quick turnaround times</li>
              <li>Competitive pricing</li>
              <li>Scalable solutions</li>
            </ul>

          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/6b2108f26a2b5bbfe848ce51e643a791943faf30-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default LaravelDevelopment